var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vacancies-email"},[_vm._v("\n  "+_vm._s(_vm.$t('vacancies.emailText'))+"\n  "),_c('a',{staticClass:"link",attrs:{"href":("mailto:" + (_vm.$t('vacancies.email')))}},[_vm._v(_vm._s(_vm.$t('vacancies.email')))])])}
var staticRenderFns = []

export { render, staticRenderFns }